export default __webpack_public_path__ + "51a1b50c5dc1590f6b428da4867f7134.png";